import React, {Component} from 'react'

class JobTableHead extends Component {
    render() {
        return (
            <thead className='thead-light'>
            <tr>
                <th/>
                <th>Tên file</th>
                <th>Thành công / Skip / Thất bại / Tổng</th>
                <th>Shipping carrier</th>
                <th>Ngày tạo</th>
                <th>Trạng thái</th>
                <th>Hành động</th>
            </tr>
            </thead>
        )
    }
}

export default JobTableHead